
import React, { useState, useEffect } from 'react';
import { Button, Box, Typography, Alert, CircularProgress } from '@mui/material';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const VerificationButton = ({ userId }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [status, setStatus] = useState(null);
    const [missingFields, setMissingFields] = useState(null);
    const [showChecklist, setShowChecklist] = useState(false); // 👈 New state

    useEffect(() => {
        axios
            .get(`${API_URL}/user/verification/status/`, { params: { user_id: userId } })
            .then(response => {
                setStatus(response.data.status);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                setError("Error fetching verification status.");
            });
    }, [userId]);

    const handleChecklistDisplay = () => {
        setShowChecklist(true); // Show checklist on first click
    };

    const handleVerify = () => {
        setLoading(true);
        setError(null);
        setMissingFields(null);

        axios
            .post(`${API_URL}/user/verification/check/`, { user_id: userId })
            .then(() => {
                setLoading(false);
                setStatus('under progress');
            })
            .catch(err => {
                setLoading(false);
                if (err.response && err.response.data.message) {
                    setMissingFields(err.response.data.message);
                } else {
                    setError("Please make sure you have submitted Aadhar data and saved all other below mentioned required details");
                }
            });
    };

    return (
        <Box
            sx={{
                backgroundColor: '#000000',
                minHeight: '10vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: 3,
            }}
        >
            {error && <Alert severity="error">{error}</Alert>}
            {missingFields && <Alert severity="warning">{missingFields}</Alert>}

            {loading && <CircularProgress sx={{ marginTop: 2 }} />}

            {status === 'pending' && (
                <>
                    {!showChecklist && (
                        <Button
                            sx={{
                                backgroundColor: '#ff8c00',
                                color: '#fff',
                                fontWeight: 'bold',
                                padding: 1.5,
                                borderRadius: '30px',
                                letterSpacing: 4,
                                mt: 2,
                                '&:hover': { backgroundColor: '#ff6f00' },
                            }}
                            onClick={handleChecklistDisplay}
                        >
                            Join as an expert
                        </Button>
                    )}

                    {showChecklist && (
                        <>
                            <Alert
                                severity="info"
                                sx={{
                                    mb: 2,
                                    backgroundColor: '#1c1c1c',
                                    color: '#fff',
                                    border: '1px solid #ff8c00',
                                    letterSpacing: 1,
                                }}
                            >
                                Please make sure you have filled in all required fields before submitting for profile verification:
                                <ul style={{ marginTop: 10, paddingLeft: 20 }}>
                                    <li>Personal Info</li>
                                    <li>Contact Info</li>
                                    <li>Address Info</li>
                                    <li>Aadhar Data</li>
                                </ul>
                            </Alert>

                            <Button
                                sx={{
                                    backgroundColor: '#ff8c00',
                                    color: '#fff',
                                    fontWeight: 'bold',
                                    padding: 1.5,
                                    borderRadius: '30px',
                                    letterSpacing: 4,
                                    mt: 2,
                                    '&:hover': { backgroundColor: '#ff6f00' },
                                }}
                                onClick={handleVerify}
                            >
                                Submit for Verification
                            </Button>
                        </>
                    )}
                </>
            )}


            {status === 'under progress' && (
                <Typography sx={{ color: '#ff8c00', marginTop: 3, letterSpacing: 4 }}>
                    Verification is under progress.
                </Typography>
            )}


            {status === 'approved' && (
                <Typography sx={{ color: '#4caf50', marginTop: 3, letterSpacing: 4 }}>
                    You are a verified user.
                </Typography>
            )}
        </Box>
    );
};

export default VerificationButton;
